<template>
  <div class="investors-page">
    <Nav />
    <div class="login-page">
      <div class="left-section">
        <div class="brand animate-element" data-animate="slide-left">
          <h1 class="brand-title">QINYUAN GROUP</h1>
          <!-- 替换为标准合规英文企业简介，适配海外推广 -->
          <p class="brand-slogan">
            QINYUAN GROUP focuses on providing one-stop services for polyurethane, polyvinyl chloride and EVA copolymer
            industries. We supply chemical raw materials, industrial machinery and professional technical services,
            which are widely used in shoe manufacturing, synthetic leather, rigid & soft PU foam, EVA sheet, PVC belt
            and other fields.
            Founded in 2013, after 13 years of steady development, our products have been exported to more than 20
            countries including Thailand, India, Vietnam, Indonesia, Pakistan, Dubai, Iran, Turkey, Russia, Mexico and
            other regions. We have established stable friendly cooperation with clients all over the world.
            We will keep providing reliable high-quality products and considerate services, and sincerely look forward
            to establishing long-term win-win cooperation with global partners.
          </p>
          <div class="brand-divider"></div>
          <p class="brand-desc">Global Industrial Solutions & International Trade</p>
          <div class="brand-features">
            <span>Professional Team</span>
            <span>Global Network</span>
            <span>High-quality Service</span>
          </div>
        </div>
      </div>
      <div class="right-section">
        <div class="login-card animate-element" data-animate="slide-right">
          <div class="login-header">
            <h3 class="login-title">Account Login</h3>
            <p class="login-subtitle">Hello, you can quickly log in to the system by entering your information.</p>
          </div>
          <form class="login-form">
            <div class="input-group">
              <span class="input-prefix">+86</span>
              <input type="tel" placeholder="Please enter your phone number" class="input-field" required />
            </div>
            <div class="input-group">
              <input type="password" placeholder="Please enter the password" class="input-field" required />
            </div>
            <button type="submit" class="login-button">LOG IN</button>
            <p class="user-agreement">Logging in is deemed as agreeing to the User Agreement and Privacy Policy.</p>
          </form>
          <div class="login-footer">
            <div class="footer-logo">
              <!-- 修改图片alt为英文SEO关键词 -->
              <img src="@/assets/logo2.png" alt="QINYUAN GROUP Official Brand Logo Industrial Trade Enterprise" />
              <span>QINYUAN GROUP</span>
            </div>
            <p class="copyright">© 2025 QINYUAN GROUP. All rights reserved.</p>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
export default {
  name: "InvestorsPage",
  // 新增页面专属SEO标题
  head() {
    return {
      title:
        "QINYUAN GROUP | PU PVC EVA Chemical Raw Materials Global Trade Service",
      meta: [
        {
          name: "description",
          content:
            "QINYUAN GROUP established in 2013, provides one-stop industrial service including PU, PVC, EVA chemical raw materials, production machinery and technical support. Products apply for shoes, synthetic leather, PU foam, EVA sheet, PVC belt etc. Exported to over 20 countries worldwide, supply high quality products and professional global trade service.",
        },
        {
          name: "keywords",
          content:
            "PU raw materials, PVC industrial materials, EVA copolymer, chemical raw materials supply, synthetic leather material, PU foam material, shoe making raw material, industrial machinery service, global chemical trade, one stop industrial service",
        },
      ],
    };
  },
  mounted() {
    this.resetAnimation();
    this.initAnimation();
    setTimeout(() => {
      this.handleScroll();
    }, 100);
    window.addEventListener("scroll", this.handleScroll, { passive: true });
    document.title =
      "LOG IN | PU PVC EVA Chemical Raw Materials & Industrial Machinery Supplier";
  },
  activated() {
    this.resetAnimation();
    this.initAnimation();
    setTimeout(() => {
      this.handleScroll();
    }, 100);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    resetAnimation() {
      const elements = document.querySelectorAll(".animate-element");
      elements.forEach((el) => {
        el.style.opacity = "0";
        el.style.transform = "translateX(0) translateY(0) scale(1)";
      });
    },
    initAnimation() {
      const elements = document.querySelectorAll(".animate-element");
      elements.forEach((el) => {
        el.style.transition = "all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94)";
        const animateType = el.dataset.animate;
        if (animateType === "slide-left") {
          el.style.transform = "translateX(-200px)";
        } else if (animateType === "slide-right") {
          el.style.transform = "translateX(200px)";
        } else if (animateType === "slide-up") {
          el.style.transform = "translateY(50px) scale(0.9)";
        }
      });
    },
    handleScroll() {
      const elements = document.querySelectorAll(".animate-element");
      elements.forEach((el) => {
        const rect = el.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        if (rect.top < windowHeight * 0.85) {
          el.style.opacity = "1";
          el.style.transform = "translateX(0) translateY(0) scale(1)";
        }
      });
    },
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.investors-page {
  min-height: 100vh;
  overflow-x: hidden;
  margin: 0;
  padding: 0;
}
.login-page {
  display: flex;
  min-height: 100vh;
  /* 背景图如需加alt在外层页面统一配置，此处仅保留原样式不动 */
  background: url("@/assets/bg-login.png") no-repeat center center;
  background-size: cover;
  overflow-x: hidden;
  background-attachment: fixed;
}
.left-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 120px;
  color: #fff;
  text-align: left;
  position: relative;
  z-index: 2;
}
.brand {
  transform: translateX(-60px);
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.brand-title {
  font-size: 62px;
  font-weight: 800;
  line-height: 1.1;
  letter-spacing: 1px;
  text-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
}
.brand-slogan {
  font-size: 16px;
  font-weight: 300;
  line-height: 1.6;
  opacity: 0.95;
  max-width: 1000px;
  margin-top: 20px;
}
.brand-divider {
  width: 80px;
  height: 2px;
  background: #fff;
  opacity: 0.8;
  margin: 28px 0;
}
.brand-desc {
  font-size: 16px;
  font-weight: 300;
  opacity: 0.9;
  letter-spacing: 0.5px;
  margin-bottom: 20px;
}
.brand-features {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}
.brand-features span {
  font-size: 14px;
  font-weight: 400;
  padding: 6px 16px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 20px;
  opacity: 0.9;
}
.right-section {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 60px 0;
  background: transparent;
}
.login-card {
  width: 450px;
  padding: 50px 40px;
  border-radius: 20px;
  background: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
}
.login-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 25px 70px rgba(0, 0, 0, 0.2);
}
.login-header {
  margin-bottom: 30px;
}
.login-title {
  font-size: 44px;
  font-weight: 700;
  color: #1d2129;
  margin-bottom: 8px;
}
.login-subtitle {
  font-size: 14px;
  color: #86909c;
  line-height: 1.5;
}
.login-form {
  width: 100%;
}
.input-group {
  margin-top: 30px;
  margin-bottom: 34px;
  position: relative;
}
.input-prefix {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: #86909c;
  font-size: 14px;
  border-right: 1px solid #e5e6eb;
  padding-right: 12px;
}
.input-field {
  width: 100%;
  height: 50px;
  padding: 0 20px;
  padding-left: 56px;
  border: 1px solid #e5e6eb;
  border-radius: 12px;
  font-size: 18px;
  color: #1d2129;
  background: #ffffff;
  transition: all 0.3s ease;
}
.input-group:not(:first-child) .input-field {
  padding-left: 20px;
}
.input-field::placeholder {
  color: #c9cdd4;
}
.input-field:focus {
  outline: none;
  border-color: #e02020;
  box-shadow: 0 0 0 4px rgba(224, 32, 32, 0.08);
}
.input-field:hover {
  border-color: #d0d3d9;
}
.login-button {
  width: 100%;
  height: 50px;
  background: #e02020;
  color: #ffffff;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin: 0 0 18px 0;
}
.login-button:hover {
  background: #c91c1c;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(224, 32, 32, 0.15);
}
.user-agreement {
  font-size: 14px;
  color: #86909c;
  text-align: center;
  line-height: 1.7;
}
.login-footer {
  margin-top: 110px;
  padding-top: 24px;
  border-top: 1px solid #f2f3f5;
  text-align: center;
}
.footer-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 8px;
}
.footer-logo img {
  width: 24px;
  height: 24px;
}
.footer-logo span {
  font-size: 14px;
  font-weight: 600;
  color: #1d2129;
}
.copyright {
  font-size: 12px;
  color: #c9cdd4;
  line-height: 1.7;
}
@media (max-width: 992px) {
  .login-page {
    flex-direction: column;
    min-height: auto;
  }
  .left-section {
    padding: 60px 40px;
    align-items: center;
    text-align: center;
  }
  .brand {
    transform: translateX(0);
    align-items: center;
  }
  .brand-title {
    font-size: 36px;
  }
  .brand-features {
    justify-content: center;
  }
  .right-section {
    width: 100%;
    padding: 40px 0;
  }
  .login-card {
    width: 90%;
    max-width: 450px;
    padding: 40px 30px;
  }
}
@media (max-width: 768px) {
  .left-section {
    padding: 40px 20px;
  }
  .brand-title {
    font-size: 32px;
  }
  .brand-slogan {
    font-size: 16px;
  }
  .login-card {
    padding: 30px 20px;
  }
  .login-title {
    font-size: 22px;
  }
  .input-field {
    height: 46px;
  }
  .login-button {
    height: 46px;
  }
}
.ani-top {
  opacity: 0;
  transform: translateY(60px);
  transition: all 1s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}
.ani-bottom {
  opacity: 0;
  transform: translateY(60px);
  transition: all 1s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}
.ani-left {
  opacity: 0;
  transform: translateX(-60px);
  transition: all 1s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}
.ani-right {
  opacity: 0;
  transform: translateX(60px);
  transition: all 1s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}
.ani-scale {
  opacity: 0;
  transform: scale(0.8);
  transition: all 1s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}
.active .ani-top,
.active .ani-bottom,
.active .ani-left,
.active .ani-right {
  opacity: 1;
  transform: translate(0);
}
.active .ani-scale {
  opacity: 1;
  transform: scale(1);
}
@media (max-width: 992px) {
  .nav-links {
    gap: 1rem;
  }
}
@media (max-width: 768px) {
  .navbar .container {
    flex-direction: column;
    gap: 1rem;
  }
  .nav-links {
    flex-wrap: wrap;
    justify-content: center;
  }
}
</style>